<template>
  <div class="dialog-container wt-dialog-container ">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="orderGoodsList" slot-scope="data">
          <span>{{ transGoodsName(data.row.orderGoodsList) }}</span>
        </template>
       </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'SiteGoodsExchangeViewTab',
  isAutoComponent: true,
  props: ['siteId'],
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULES_GOODS',
        formComponent: {
          list: { type: 'default', value: '/modules/site/siteOrderList', params: { siteId: '' }}
        },
        formInputsData: [{ name: '下单时间', key: 'dataTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/site/siteOrderListImport',
          fileName: '兑换记录' }],
        formTableData: [
          { name: '订单编号', key: 'orderNumber', type: 'text' },
          { name: '商品名称', key: 'orderGoodsList', type: 'custom' },
          { name: '兑换积分', key: 'totalIntegral', type: 'text' },
          { name: '用户昵称', key: 'nickName', type: 'text' },
          { name: '手机号', key: 'phone', type: 'text' },
          { name: '下单时间', key: 'createTime', type: 'text' },
          { name: '核销时间', key: 'exchangeTime', type: 'text' },
          { name: '核销人', key: 'employeesName', type: 'text' }],
        formTableButtonsData: [],
        formResult: { },
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: true, buttonHidden: true }
      }
    }
  },
  created() {
    this.form.formComponent.list.params.siteId = this.siteId
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {},
    transGoodsName(data) {
      const names = []
      for (const item of data) {
        names.push(item.goodsTitle)
      }
      return names.join('、')
    }
  }
}
</script>
